import React, { useState } from 'react';
import { Row, Col, Card, Button, Input, FormFeedback } from 'reactstrap';
import { connect } from "react-redux";
import CreateAccountDetailsService from '../../../../../../../Service/OPSServices/AccountDetailsService/CreateAccountDetailsService';

function AddNewAccountsDetails(props) {
  const [formData, setFormData] = useState({
    name: '',
    Account_Types: '',
    address: '',
    admin: '',
    email: '',
    phone: '',
    pricingPlan: '',
  });

  const [errors, setErrors] = useState({});

  // Validation for required fields
  const isInvalid = () => {
    const requiredFields = ['name', 'Account_Types', 'address', 'admin', 'email', 'phone'];
    return requiredFields.some(field => !formData[field]) ||
           formData.email !== formData.email.trim() || // Email should not have leading/trailing spaces
           !/\S+@\S+\.\S+/.test(formData.email) || // Email should contain @
           !/^\d+$/.test(formData.phone) 
  };

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//     setErrors({ ...errors, [e.target.name]: '' }); // Clear error on change
//   };


  // Updated handleChange function with real-time validation
  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(value); // Optional: for debugging purposes

    // Update the formData state
    setFormData({
      ...formData,
      [name]: value,
    });

    // Real-time validation
    if (name !== 'pricingPlan' && value.trim() === '') {
      setErrors((prev) => ({
        ...prev,
        [name]: `${name.charAt(0).toUpperCase() + name.slice(1)} cannot be blank.`,
      }));
    } else if (name === 'email' && !/\S+@\S+\.\S+/.test(value)) {
      setErrors((prev) => ({
        ...prev,
        email: 'Please enter a valid email address.',
      }));
    } else if (name === 'phone' && !/^\d{10}$/.test(value)) {
      setErrors((prev) => ({
        ...prev,
        phone: 'Phone number must be exactly 10 digits and contain only numbers.',
      }));
    }
    else {
      // Clear the error for this field if it's valid
      setErrors((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };

  const handleSubmit = () => {
    if (isInvalid()) return; // Prevent submit if invalid

    CreateAccountDetailsService(props.token, formData).then((result) => {
      if (result) {
        props.handleCloseUpdateAccountDetailsPopup(result);
      }
    });
  };

  return (
    <Card className="curve-popup p-3">
      <Row>
        {[
          ['name', 'Name'],
          ['Account_Types', 'Account Type'],
          ['admin', 'Contact'],
          ['email', 'Email'],
          ['phone', 'Phone'],
          ['pricingPlan', 'Pricing Plan($)'],
          ['address', 'Address'],
        ].map(([field, label]) => (
          <Col md={12} className="d-flex align-items-center mt-2" key={field}>
            <Col md={3} className="text-end pe-2">
              <h6><b>
        {label}
        {['name', 'Account_Types', 'address', 'admin', 'email', 'phone'].includes(field) && (
          <span className="text-danger">*</span>
        )} :
      </b></h6>
            </Col>
            <Col md={9}>
              {field === 'Account_Types' ? (
                <Input
                  type="select"
                  name={field}
                  value={formData[field]}
                  onChange={handleChange}
                  invalid={!!errors[field]}
                >
                  <option value="">Select Account Type</option>
                  {props.accountTypes && props.accountTypes.map((type) => (
                    <option key={type.id} value={type.accountTypes}>
                      {type.accountTypes}
                    </option>
                  ))}
                </Input>
                ) : field === 'address' ? (
                  <Input
                    type="textarea"
                    name={field}
                    rows="2"
                    className="w-100"
                    value={formData[field]}
                    onChange={handleChange}
                    placeholder={label}
                    invalid={!!errors[field]}
                  />
              ) : (
                <Input
                  type="text"
                  name={field}
                  value={formData[field]}
                  onChange={handleChange}
                  placeholder={label}
                  invalid={!!errors[field]}
                />
              )}
              {errors[field] && <FormFeedback>{errors[field]}</FormFeedback>}
            </Col>
          </Col>
        ))}
        <Col className="d-flex justify-content-center mt-2">
          <Button className="btn-background-color" onClick={handleSubmit} disabled={isInvalid()}>
            Submit
          </Button>
        </Col>
      </Row>
    </Card>
  );
}

const mapStateToProps = (state) => {
  return {
    token: state.loggedUser.token,
    accessLevel: state.loggedUser.accessLevel,
    status: state.loggedUser.status,
    error: state.loggedUser.error,
    adProfiles: state.accountOverview.landing.adProfiles,
  };
};

export default connect(mapStateToProps)(AddNewAccountsDetails);
